<script setup>
import moment from "moment";
import Flagged from './inspections/Flagged.vue';
import StumpsTable from './stumps/StumpsTable.vue'
import CustomerRequests from './works/CustomerRequests.vue';
import CompletedWorks from "./CompletedWorks.vue";
import {computed, onMounted, ref} from "vue";
import forestreeHelpers from "@/helpers/forestreeHelpers";
import axios from 'axios'

const props = defineProps({
    access: {},
    permissions: {},
})

const works = ref([])
const customerRequests = ref([])
const projects = ref([])
const inspections = ref([])
const suburbs = ref([])
const stumps = ref([])
const removedStumps = ref([])
const selectedSuburb = ref("Show All")
const worksTotal = ref(null)
const tasks = ref(null)
const defaults = ref(null)
const type = ref('works')
const today = ref(moment().format("dddd Do MMM YYYY"))
const year = ref(parseInt(moment().format("YYYY")))
const currYear = ref(parseInt(moment().format("YYYY")))
const sortBy = ref('estimated_date')
const sortAsc = ref(true)
const page = ref(1)
const completedData = ref({})
const showLimit = ref(50)
const loading = ref(true)
const downloading = ref(false)
const downloadCsvId = ref(null)
const downloadFilename = ref(null)
const inspCount = ref(0)
const totalInspectionCount = ref(0)
const revCount = ref(0)
const showReview = ref(false)


function getPlantings() {
    loading.value = true;
    axios
        .get("/api/assign/mine")
        .then(response => {
            customerRequests.value = response.data.customerRequests;
            works.value = response.data.assignments;
            tasks.value = response.data.workTasks;
            projects.value = response.data.projects;
            inspections.value = response.data.inspections;
            inspCount.value = response.data.inspectionCount;

            if (props.permissions && props.permissions.flag_review && response.data.defaults.flag_review) {
                showReview.value = true;
                revCount.value = response.data.reviewCount;
                totalInspectionCount.value = response.data.inspectionCount + response.data.reviewCount;
            } else {
                totalInspectionCount.value = response.data.inspectionCount
            }

            stumps.value = response.data.stumps;
            removedStumps.value = response.data.removedStumps;
            defaults.value = response.data.defaults;
            getSuburbs();

            if (works.value.length === 0) {
                type.value = 'cr';
                if (customerRequests.value.length === 0) {
                    type.value = 'inspections';
                    if (inspections.value.length === 0) {
                        type.value = 'stumps';
                        if (stumps.value.length === 0) {
                            type.value = 'projects';
                            if (projects.value.length === 0) {
                                type.value = 'works';
                            }
                        }
                    }
                }
            }

            response.data.unlinkedAssignments.map(work => {
                work.is_unlinked = true;
                work.tree_works = {
                    estimate_finish: work.t1_works.estimated_finish,
                    work_complete: work.t1_works.woStatus === 'Complete',
                }
                works.value.push(work);
            });

            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
            loading.value = false;
        });
}

function getCompletedData() {
    axios.get("/api/assign/complete").then(res => {
        completedData.value = res.data
    }).catch((error) => {
        console.log(error)
    })

}

function downloadCSV() {
    window.location.href = "/api/reporting/csv/download/" + downloadFilename.value;
}

function downloadWorksCSV() {
    downloadFilename.value = null;
    downloadCsvId.value = null;
    downloading.value = true;
    axios.get("/api/assign/mine/export").then(response => {
        downloadCsvId.value = response.data.csv.id;
        checkDownloads();
    }).catch((error) => {
        console.log(error)
    });
}

function checkDownloads() {
    axios
        .get("api/assign/mine/check/" + downloadCsvId.value)
        .then((response) => {
            if (response.data.csv.status === "pending") {
                setTimeout(() => {
                    checkDownloads();
                }, 5000);
            } else {
                //downloading.value = false;
                downloadFilename.value = response.data.csv.filename;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function getSuburbs() {
    suburbs.value = [];
    works.value.map(work => {
        if (!suburbs.value.includes(work.tree_works.city)) {
            suburbs.value.push(work.tree_works.city);
        }
    });
    // customerRequests.value.map(work => {
    //     if (!suburbs.value.includes(work.crm.crm_suburb)) {
    //         suburbs.value.push(work.crm.crm_suburb);
    //     }
    // });
    suburbs.value.sort();
}


function getIcon(attr) {
    if (attr == "m") {
        return "Works";
    } else if (attr == "i") {
        return "Inspection";
    } else if (attr == "w") {
        return "Watering";
    } else if (attr == "s") {
        return "Stump";
    } else if (attr == "p") {
        return "Planting";
    } else {
        return "1";
    }
}

function formatWorkTask(arrayString) {
    var array = arrayString.substring(1, arrayString.length - 1).split(",");
    return array;
}

function projectType(p) {
    if (p.project_type_id === 3) {
        return 'Proactive Works';
    } else if (p.project_type_id === 5) {
        return 'Watering';
    } else if (p.project_type_id === 7) {
        return 'Inspections';
    } else if (p.project_type_id === 8) {
        return 'Planting';
    } else if (p.project_type_id === 9) {
        return 'Stumps';
    } else if (p.project_type_id === 10) {
        return 'Works';
    } else {
        return 'General';
    }
}

function projectUrl(p) {
    if (p.project_type_id === 3) {
        return '/projects/' + p.url_link + '?projectId=' + p.url_link;
    } else if (p.project_type_id === 5) {
        return '/watering?projectId=' + p.url_link;
    } else if (p.project_type_id === 7) {
        return '/map?projectId=' + p.url_link;
    } else if (p.project_type_id === 8) {
        return '/vacant-map?projectId=' + p.url_link;
    } else if (p.project_type_id === 9) {
        return '/stumps?projectId=' + p.url_link;
    } else if (p.project_type_id === 10) {
        return '/maintenance-map?projectId=' + p.url_link;
    } else {
        return '/projects/' + p.url_link + '?projectId=' + p.url_link;
    }
}

function sortArray(array) {
    if (sortBy.value === 'updated_at') {
        if (sortAsc.value) {
            return array.sort((a, b) => new Date(b.tree_works.updated_at) - new Date(a.tree_works.updated_at));
        }
        if (!sortAsc.value) {
            return array.sort((b, a) => new Date(b.tree_works.updated_at) - new Date(a.tree_works.updated_at));
        }
    }

    if (sortBy.value === 'estimated_date') {
        if (sortAsc.value) {
            return array.sort((a, b) => new Date(b.tree_works.estimate_finish) - new Date(a.tree_works.estimate_finish));
        }
        if (!sortAsc.value) {
            return array.sort((b, a) => new Date(b.tree_works.estimate_finish) - new Date(a.tree_works.estimate_finish));
        }
    }

    if (sortBy.value === 'assigned_date') {
        if (sortAsc.value) {
            return array.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
        if (!sortAsc.value) {
            return array.sort((b, a) => new Date(b.created_at) - new Date(a.created_at));
        }
    }

    return array;
}

function getColour(name) {

    if (name.includes('Green')) {
        return '#4caf50';
    } else if (name.includes('Red')) {
        return '#ff5722';
    } else if (name.includes('Blue')) {
        return '#1367bf';
    } else if (name.includes('Yellow')) {
        return '#eaf31a';
    } else if (name.includes('Orange')) {
        return '#ffaa49';
    } else if (name.includes('Purple')) {
        return '#df49ff';
    } else if (name.includes('Pink')) {
        return '#ff49a9';
    } else {
        return '';
    }

}

function getAssignedTally() {
    return works.value.length +
        inspections.value.length +
        customerRequests.value.length +
        projects.value.length
}

onMounted(() => {
    getPlantings();
    getCompletedData();
})


const filteredWorkSuburbs = computed(() => {
    if (selectedSuburb.value !== "Show All") {
        var w = works.value.filter(work => {
            return work.tree_works.city === selectedSuburb.value;
        });

        return sortArray(w).slice(0, showLimit.value);

        //return sortArray.value(w);
    }
    //console.log(sortArray.value(works.value));

    return sortArray(works.value).slice(0, showLimit.value);

    //return sortArray.value(works.value);
    //return works.value;
})
const filteredWorkCrs = computed(() => {
    if (selectedSuburb.value !== "Show All") {
        return customerRequests.value.filter(work => {
            return work.crm.crm_suburb === selectedSuburb.value;
        });
    }
    return customerRequests.value;
})
// created() {
//     $on.value("refreshList", () => {
//         getPlantings.value();
//     });
// }
</script>

<template>
    <div class="flex flex-wrap lg:flex-no-wrap w-full lg:w-3/4 lg:p-4">
        <div class="h-auto bg-white forestree-box all-rounded w-full lg:ml-6">
            <div class="bg-white rounded shadow-sm  mt-6 pb-6">

                <div class="flex flex-wrap lg:flex-no-wrap mt-6 py-4 px-1 lg:px-8 w-full border-b border-slate-300">
          <span
              @click.prevent="type = 'works'"
              :class="type === 'works' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
              class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
            Works
            <span :class="works?.length > 0 ? 'bg-red-600 text-red-100' : 'bg-slate-100 text-slate-500'"
                  class="hidden px-2 rounded-full font-semibold md:inline-block">{{ works?.length }}</span>
          </span>
                    <span
                        v-if="customerRequests?.length"
                        @click.prevent="type = 'cr'"
                        :class="type === 'cr' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                        class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
            Customer Requests
            <span :class="customerRequests?.length > 0 ? 'bg-red-600 text-red-100'  : 'bg-slate-100 text-slate-500'"
                  class="hidden px-2 rounded-full font-semibold md:inline-block">{{ customerRequests?.length }}</span>
          </span>
                    <span
                        @click.prevent="type = 'inspections'"
                        :class="type === 'inspections' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                        class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
            Inspections
            <span :class="totalInspectionCount > 0 ? 'bg-red-600 text-red-100'  : 'bg-slate-100 text-slate-500'"
                  class="hidden px-2 rounded-full font-semibold md:inline-block">{{ totalInspectionCount }}</span>
          </span>
                    <span
                        @click.prevent="type = 'stumps'"
                        :class="type === 'stumps' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                        class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
            Stump Removals
            <span :class="stumps?.length > 0 ? 'bg-red-600 text-red-100'  : 'bg-slate-100 text-slate-500'"
                  class="hidden px-2 rounded-full font-semibold md:inline-block">{{ stumps?.length }}</span>
          </span>
                    <span
                        @click.prevent="type = 'projects'"
                        :class="type === 'projects' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                        class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
            Projects
            <span :class="projects?.length > 0 ? 'bg-red-600 text-red-100'  : 'bg-slate-100 text-slate-500'"
                  class="hidden px-2 rounded-full font-semibold md:inline-block">{{ projects?.length }}</span>
          </span>
                </div>

                <div class="pt-5 px-1 lg:px-8" v-if="type === 'inspections'">

                    <flagged
                        :assigned-inspections="inspections ?? []"
                        :access="access"
                        :permissions="permissions"
                        :tasks="tasks"
                        :inspCount="inspCount"
                        :revCount="revCount"
                        :showReview="showReview"
                        :showPlanting="false"
                        @refresh="getPlantings"
                    />
                </div>

                <div class="px-1 lg:px-8" v-if="type === 'stumps'">

                    <stumps-table
                        :stumps="stumps"
                        :removedStumps="removedStumps"
                        :permissions="permissions"
                    />
                </div>

                <div class="px-1 lg:px-8" v-if="type === 'cr'">

                    <customer-requests
                        :requests="customerRequests"
                        :permissions="permissions"
                        :users="null"
                        :defaults="defaults"
                    />


                </div>

                <div class="" v-if="type === 'works'">
                    <div class="px-1 lg:px-8 py-1">
                        <div
                            class="flex justify-between flex-wrap lg:flex-no-wrap  w-full border-b border-slate-200 py-1 "
                        >
                                <span
                                    @click.prevent="page = 1"
                                    :class="page === 1 ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                                    class="w-full text-center md:w-auto mr-0 md:mr-8 p-3 font-semibold cursor-pointer hover:text-blue-600">
                                    Open Works
                                                <span
                                                    :class="works?.length > 0 ? 'bg-red-600 text-red-100'  : 'bg-slate-100 text-slate-500'"
                                                    class="hidden px-2 rounded-full font-semibold md:inline-block">{{
                                                        works?.length
                                                    }}</span>
                                </span>
                            <span
                                @click.prevent="page = 2"
                                :class="page === 2 ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
                                class="w-full text-center md:w-auto mr-0 md:mr-8 p-3 font-semibold cursor-pointer hover:text-blue-600">
                                    Completed Works
                            </span>
                            <template v-if="page === 1">
                              <span @click.prevent="downloadWorksCSV()"
                                    class="mr-3 w-full text-center md:w-auto p-3 font-semibold ml-auto cursor-pointer hover:text-blue-600 text-blue-700 rounded-lg bg-slate-100 hover:bg-slate-200">
                                CSV Export
                              </span>
                                <a v-if="works?.length > 0" href="/maintenance-map"
                                   class="text-white rounded-lg bg-blue-600 w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-200">
                                    Show Map
                                </a>

                                <div v-if="downloading" class="relative z-40" aria-labelledby="modal-title"
                                     role="dialog" aria-modal="true">
                                    <div class="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity"
                                         aria-hidden="true"></div>
                                    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                                        <div
                                            class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                            <div
                                                class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                                <div>
                                                    <div v-if="downloadFilename"
                                                         class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                                        <svg class="h-6 w-6 text-green-600" fill="none"
                                                             viewBox="0 0 24 24" stroke-width="1.5"
                                                             stroke="currentColor" aria-hidden="true" data-slot="icon">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  d="m4.5 12.75 6 6 9-13.5"/>
                                                        </svg>
                                                    </div>
                                                    <div v-else class="w-full text-center flex justify-center">
                                                        <div class="csvloader">
                                                            Creating CSV...
                                                        </div>
                                                    </div>
                                                    <div class="mt-3 text-center sm:mt-5">
                                                        <h3 v-if="downloadFilename"
                                                            class="text-base font-semibold text-slate-900"
                                                            id="modal-title">CSV Created</h3>
                                                        <h3 v-else class="text-base font-semibold text-slate-900"
                                                            id="modal-title">Creating CSV</h3>
                                                    </div>
                                                </div>
                                                <div class="mt-5 sm:mt-6 flex justify-between">
                                                    <button @click="downloading = false" type="button"
                                                            class="w-32 inline-flex justify-center rounded-lg bg-slate-100 px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
                                                        Close
                                                    </button>
                                                    <button :disabled="!downloadFilename" @click="downloadCSV()"
                                                            type="button"
                                                            :class="downloadFilename ? 'bg-blue-600 hover:bg-blue-500' : 'bg-blue-200'"
                                                            class="w-32 inline-flex justify-center rounded-lg  px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
                                                        Download
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </template>
                            <template v-else>
                                <span class="ml-auto"></span>

                            </template>
                        </div>
                    </div>

                    <!-- Open works / Works to be completed selected  -->
                    <template v-if="page === 1">
                        <div class="px-1 lg:px-8 flex flex-wrap items-center pt-3 pb-6">
                            <div class="w-full lg:w-3/4">
                                <p class="my-3 text-xl text-slate-600">
                                    Tree Works ({{ works?.length }})
                                </p>
                                <p class="my-3 text-md text-slate-500">
                                    Trees that require Works and have been assigned to you.
                                </p>
                            </div>

                            <div v-if="loading" class="w-full h-56 text-center">
                                <img src="/loading.gif" width="60" class="mx-auto"/>
                                <h3 class="text-xl text-slate-500 leading-none mb-3">Growing your works list...</h3>
                                <h3 class="text-lg text-slate-500 leading-none mb-3">Please wait</h3>
                            </div>

                            <div v-if="works?.length" class="w-full lg:w-1/4">
                                <div class="flex justify-end">
                                    <div class="w-full items-center">
                                        <p
                                            class="whitespace-nowrap text-slate-600 text-sm uppercase font-semibold mb-2"
                                        >
                                            Filter Suburb
                                        </p>
                                        <select
                                            v-model="selectedSuburb"
                                            class="block appearance-none w-full bg-slate-100 border border-slate-200 text-slate-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-slate-500 rounded-lg"
                                            id="grid-state"
                                        >
                                            <option value="Show All"
                                            >SHOW ALL
                                            </option
                                            >
                                            <option
                                                v-for="suburb in suburbs"
                                                :value="suburb"
                                                :key="suburb"
                                            >{{ suburb }}
                                            </option
                                            >
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="works?.length" class="ftree-table striped hovered main-first-cell w-full overflow-x-auto">
                            <div class="thead bg-slate-100">
                                <div class="tr p-2">
                                    <div class="td bg-slate-100 items-center w-1/2 lg:w-1/6">Tree ID</div>
                                    <div class="td bg-slate-100 items-center w-1/2 lg:w-2/6">Tasks / NOTES</div>
                                    <div
                                        @click.prevent="sortBy = 'assigned_date';sortAsc = !sortAsc;"
                                        :class="sortBy === 'assigned_date' ? 'font-bold text-blue-600' : 'font-bold text-slate-600'"
                                        class="td bg-slate-100 items-center w-1/2 lg:w-1/6 cursor-pointer uppercase">
                                        <div class="w-full flex items-center">
                                            Assigned By
                                            <svg
                                                v-show="sortBy === 'assigned_date'"
                                                :class="!sortAsc ? 'rotate-180' : ''"
                                                class="inline h-5 w-5" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div
                                        @click.prevent="sortBy = 'updated_at';sortAsc = !sortAsc;"
                                        :class="sortBy === 'updated_at' ? 'font-bold text-blue-600' : 'font-bold text-slate-600'"
                                        class="td bg-slate-100 flex items-center w-1/2 lg:w-1/6 cursor-pointer uppercase">
                                        Last Updated
                                        <svg
                                            v-show="sortBy === 'updated_at'"
                                            :class="!sortAsc ? 'rotate-180' : ''"
                                            class="inline h-5 w-5" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                    <div
                                        @click.prevent="sortBy = 'estimated_date';sortAsc = !sortAsc;"
                                        :class="sortBy === 'estimated_date' ? 'font-bold text-blue-600' : 'font-bold text-slate-600'"
                                        class="td bg-slate-100 flex items-center w-1/2 lg:w-1/6 cursor-pointer uppercase">
                                        Due Date
                                        <svg
                                            v-show="sortBy === 'estimated_date'"
                                            :class="!sortAsc ? 'rotate-180' : ''"
                                            class="inline h-5 w-5" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tbody text-left text-slate-500">

                                <div
                                    v-for="(work, index) in filteredWorkSuburbs"
                                    :key="index"
                                    class="tr px-2 hover:bg-slate-100 cursor-pointer"
                                >
                                    <div class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center"
                                         v-if="!work.is_unlinked">
                                        <a :href="'/maintenance-map?treeId='+work.tree_works.tree_id"
                                           class="text-slate-500 font-semibold mr-3">#{{ work.tree_works.tree_id }}</a>
                                        <div class="ml-2 py-2 font-semibold">
                                            <span class="status "
                                                  :class="forestreeHelpers.getPriority(work.tree_works.priority)"></span>
                                            {{ forestreeHelpers.getPriority(work.tree_works.priority) }}
                                        </div>
                                    </div>
                                    <div class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center" v-else>
                                        <a :href="'/maintenance-map?woId=' + work.id"
                                           class="text-slate-500 font-semibold mr-3" target="_blank">Unlinked</a>
                                        <div class="ml-2 py-2 font-semibold">
                                        <span class="status "
                                              :class="forestreeHelpers.getPriority(work.t1_works.forestree_priority)"></span>
                                            {{ forestreeHelpers.getPriority(work.t1_works.forestree_priority) }}
                                        </div>
                                    </div>


                                    <div v-if="!work.is_unlinked"
                                         class="py-2 border-b border-slate-200 w-1/2 lg:w-2/6 items-center">
                                        <div v-if="work.tree_works.address"
                                             class="font-semibold pb-1 text-slate-500 text-xs">{{
                                                work.tree_works.address
                                            }}
                                        </div>
                                        <div
                                            v-if="work.tree_works.work_complete"
                                            class="w-full text-sm items-center"
                                        >
                        <span class="inline-block bg-green-500 rounded-full px-3 py-1 text-sm text-slate-200 mr-2 my-1">
                            Complete
                        </span>
                                        </div>
                                        <div
                                            v-if="work.tree_works.work_tasks && formatWorkTask(work.tree_works.work_tasks)?.length"
                                        >
                                            <template
                                                v-for="(task, index) in formatWorkTask(work.tree_works.work_tasks)"
                                                :key="index">
                                            <span
                                                v-if="forestreeHelpers.getWorkTask(task, tasks)"
                                                class="inline-block bg-slate-400 rounded-full px-3 py-0.5 mb-1 text-sm text-slate-100 mr-2">
                                                {{ forestreeHelpers.getWorkTask(task, tasks) }}
                                            </span>
                                            </template>
                                        </div>
                                        <div
                                            v-if="work.tree_works.city"
                                            class="w-full text-sm text-slate-500 items-center"
                                        >
                        <span class="inline-block bg-slate-200 rounded-full px-3 py-1 text-sm text-slate-500 mr-2">
                            {{ work.tree_works.city }}
                        </span>
                                        </div>
                                        <div class="py-2 tems-center text-slate-500">
                                            {{ work.tree_works.work_notes }}
                                        </div>
                                    </div>
                                    <div v-else
                                         class="py-2 border-b border-slate-200 w-1/2 lg:w-2/6 items-center">
                                        <div
                                            v-if="work.t1_works.work_complete"
                                            class="w-full text-sm items-center"
                                        >
                        <span class="inline-block bg-green-500 rounded-full px-3 py-1 text-sm text-slate-200 mr-2 my-1">
                            Complete
                        </span>
                                        </div>
                                        <div>
                      <span class="inline-block bg-slate-600 rounded-full px-3 py-1 mb-1 text-sm text-slate-200 mr-2">
                          {{ work.t1_works.woWorkTypeCode }}
                      </span>
                                        </div>
                                        <div class="py-2 tems-center text-slate-500">
                                            {{ work.t1_works.woDescription }}
                                        </div>
                                    </div>
                                    <div
                                        class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center text-slate-500">
                                        <div class="font-semibold pb-2 text-slate-500">{{
                                                forestreeHelpers.dateTime(work.created_at)
                                            }}
                                        </div>
                                        <avatar
                                            class="cursor-pointer -mr-1"
                                            :name="work.assigned_by.name.replace(/([0-9])/g, ' $1').trim()"
                                            :background="forestreeHelpers.getColour(work.assigned_by.name)"
                                            color="#fff"
                                            :size="30">
                                        </avatar>
                                    </div>
                                    <div
                                        class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center font-semibold pb-2 text-slate-500">
                                        {{ forestreeHelpers.dateTime(work.tree_works.updated_at) }}
                                    </div>
                                    <div
                                        class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center font-semibold pb-2 text-slate-500"
                                        v-if="!work.is_unlinked">
                                        {{ forestreeHelpers.justDate(work.tree_works.estimate_finish) }}
                                    </div>
                                    <div
                                        class="py-2 border-b border-slate-200 w-1/2 lg:w-1/6 items-center font-semibold pb-2 text-slate-500"
                                        v-else>{{ forestreeHelpers.justDate(work.estimated_finish) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="showLimit < works?.length" class="w-full flex justify-center py-3">
                            <button @click="showLimit = showLimit + 50"
                                    class="py-2 px-5 bg-slate-200 text-slate-700 font-semibold rounded-lg">Show More
                            </button>
                        </div>
                    </template>
                    <!--  Completed work selected  -->
                    <template v-else-if="page === 2">
                        <completed-works :completed-data="completedData"/>
                    </template>

                </div>


                <div v-if="type === 'projects'">
                    <div class="flex">
                        <div class="px-1 lg:px-8 w-full lg:w-3/4 pb-4">
                            <p class="my-3 text-xl text-slate-600">
                                Projects Assigned to Me ({{ projects?.length }})
                            </p>
                            <p class="my-3 text-md text-slate-500">
                                Projects are an area of trees requiring work. This can be works, inspections, planting,
                                stump removal or watering.
                            </p>
                        </div>
                    </div>

                    <div v-if="projects?.length" class="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul>
                            <li
                                v-for="(work, index) in projects"
                                :key="index"
                                class="border border-slate-200">
                                <a :href="projectUrl(work.projects)"
                                   class="block hover:bg-slate-100 focus:outline-none focus:bg-slate-50 transition duration-150 ease-in-out">
                                    <div class="px-4 py-4 sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <div class="text-lg leading-5 font-medium text-blue-600 truncate">
                                                <div class="text-sm text-slate-500 uppercase">
                                                    {{ projectType(work.projects) }} Project
                                                </div>
                                                <div>{{ work.projects.name }} (#{{ work.projects.id }})</div>
                                                <div class="text-sm text-slate-800">{{ work.projects.notes }}</div>
                                                <div v-if="work.projects.project_type_id === 3"
                                                     class="text-sm text-slate-600 flex items-center">Progress:
                                                    {{ work.projects.total_complete }} / {{ work.projects.total_trees }}
                                                    <svg
                                                        v-if="work.projects.total_complete >= work.projects.total_trees"
                                                        class="flex-shrink-0 ml-1 h-5 w-5 text-green-400"
                                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor">
                                                        <path fill-rule="evenodd"
                                                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                              clip-rule="evenodd"/>
                                                    </svg>
                                                </div>
                                                <div class="mt-2 flex-shrink-0 flex">
                                                    <!-- <span class="px-2 mr-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-400 text-orange-100 hover:underline hover:bg-orange-500">
                                                      <a
                                                        target="_blank"
                                                        :href="'api/tree/projects/export/' + work.projects.url_link">
                                                        CSV Export
                                                      </a>
                                                    </span> -->
                                                    <span
                                                        v-if="work.projects.project_type_id === 8 && !work.projects.live"
                                                        class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-400 text-orange-100 hover:underline hover:bg-orange-500">
                            <a
                                download
                                :href="'api/tree/projects/summary/' + work.projects.url_link">
                              CSV Export Species Summary
                            </a>
                          </span>
                                                    <span
                                                        v-if="work.projects.project_type_id === 5 && work.projects.live"
                                                        class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-400 text-orange-100 hover:underline hover:bg-orange-500">
                            <a
                                download
                                :href="'api/tree/water-trees/' + work.projects.url_link + '/csv'">
                              CSV Export Watering List
                            </a>
                          </span>
                                                    <span v-if="work.projects.project_type_id === 10"
                                                          class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-orange-400 text-orange-100 hover:underline hover:bg-orange-500">
                            <a
                                download
                                :href="'api/public/project/export/' + work.projects.url_link">
                              CSV Export Works List
                            </a>
                          </span>
                                                </div>
                                            </div>
                                            <div class="ml-2 flex-shrink-0 flex">
                        <span
                            class="px-2 py-1 inline-flex text-sm leading-5 font-semibold rounded-full bg-blue-600 text-blue-100">
                          {{ work.projects.status }}
                        </span>
                                            </div>
                                        </div>
                                        <div class="mt-1 sm:flex sm:justify-between">
                                            <div
                                                v-if="work.projects?.work_tasks && formatWorkTask(work.projects.work_tasks)?.length"
                                                class="sm:flex">
                                                <div class="mr-6 flex items-center text-sm leading-5 text-slate-500">
                                                    <div
                                                        v-if="work.projects?.work_tasks && formatWorkTask(work.projects.work_tasks)?.length"
                                                        class="py-1">
                                <span
                                    v-for="(task, index) in formatWorkTask(work.projects.work_tasks)" :key="index"
                                    v-if="forestreeHelpers.getWorkTask(task, tasks)"
                                    class="inline-block bg-slate-600 rounded-full px-3 py-1 my-1
                                text-sm text-slate-200 mr-2">
                                    {{ forestreeHelpers.getWorkTask(task, tasks) }}
                                </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 flex items-center text-sm leading-5 text-slate-500 sm:mt-0">
                        <span>
                          {{ forestreeHelpers.dateTime(work.projects.updated_at) }}
                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.td-block-wrap {
    display: block !important;
}

.tbody .tr {
    display: -webkit-inline-box;
}

.rotate-180 {
    transform: rotate(180deg);
}
</style>
